"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var AdapterMoment_1 = require("@mui/x-date-pickers/AdapterMoment");
var LocalizationProvider_1 = require("@mui/x-date-pickers/LocalizationProvider");
var DateTimePicker_1 = require("@mui/x-date-pickers/DateTimePicker");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var moment_1 = __importDefault(require("moment"));
function BasicDateTimePicker(props) {
    var _a, _b, _c, _d, _e;
    var _f = props.label, label = _f === void 0 ? "Basic date time picker" : _f, value = props.value, errorText = props.errorText, onChange = props.onChange, colors = props.colors;
    var convertedValue = typeof value === "string" ? (0, moment_1.default)(value) : value;
    var _g = (0, react_1.useState)(""), error = _g[0], setError = _g[1];
    var _h = (0, react_1.useState)(false), open = _h[0], setOpen = _h[1];
    (0, react_1.useEffect)(function () {
        setError(errorText !== null && errorText !== void 0 ? errorText : "");
    }, [errorText]);
    return (react_1.default.createElement("div", { className: "grid" },
        react_1.default.createElement(LocalizationProvider_1.LocalizationProvider, { dateAdapter: AdapterMoment_1.AdapterMoment },
            react_1.default.createElement(DateTimePicker_1.DateTimePicker, { label: label, value: convertedValue !== null && convertedValue !== void 0 ? convertedValue : (0, moment_1.default)(), ampm: false, open: open, onClose: function () {
                    setOpen(false);
                }, closeOnSelect: false, slotProps: {
                    actionBar: {
                        actions: ["today", "accept"],
                    },
                    textField: {
                        InputProps: {
                            endAdornment: (react_1.default.createElement("div", { className: "customIcon px-4 py-3 cursor-pointer hover:bg-gray-200 rounded-lg mr-2 transition-colors duration-200", onClick: function () {
                                    console.log("open", open);
                                    setOpen(!open);
                                } },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faCalendarAlt }))),
                        },
                    },
                }, sx: {
                    ".MuiInputBase-root": {
                        color: (_a = colors === null || colors === void 0 ? void 0 : colors.textColor) !== null && _a !== void 0 ? _a : "text-black",
                        paddingRight: 0,
                        borderRadius: "0.5rem",
                        backgroundColor: (_b = colors === null || colors === void 0 ? void 0 : colors.backgroundColor) !== null && _b !== void 0 ? _b : "bg-gray-100",
                    },
                    ".MuiInputLabel-root": {
                        color: (_c = colors === null || colors === void 0 ? void 0 : colors.labelColor) !== null && _c !== void 0 ? _c : "text-black",
                    },
                    ".MuiOutlinedInput-notchedOutline": {
                        borderRadius: "0.5rem",
                        border: "1px solid ".concat((_d = colors === null || colors === void 0 ? void 0 : colors.borderColor) !== null && _d !== void 0 ? _d : "border-gray-400"),
                    },
                    ".MuiInputBase-root .customIcon": {
                        color: (_e = colors === null || colors === void 0 ? void 0 : colors.iconColor) !== null && _e !== void 0 ? _e : "text-black",
                    },
                }, 
                // disablePast={true}
                views: ["year", "month", "day", "hours", "minutes"], format: "DD/MM/YYYY HH:mm", 
                // views={["year", "month", "day", "hours", "minutes"]}
                timeSteps: {
                    minutes: 1,
                }, onChange: function (newValue) {
                    console.log("newValue", newValue);
                    if (onChange) {
                        onChange(newValue);
                    }
                } }),
            error && react_1.default.createElement("div", { className: "text-red-500 text-xs" }, error))));
}
exports.default = BasicDateTimePicker;
